/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Session_SearchInputs */

const en_session_search = /** @type {(inputs: Session_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search recipes`)
};

const de_session_search = /** @type {(inputs: Session_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezepte durchsuchen`)
};

/**
* | output |
* | --- |
* | "Search recipes" |
*
* @param {Session_SearchInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const session_search = /** @type {((inputs?: Session_SearchInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Session_SearchInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_session_search(inputs)
	return en_session_search(inputs)
});